import { createAuthClient } from 'better-auth/client';

export const authClient = createAuthClient({
  baseURL: "https://api.nduka.io",
  credentials: "include", // Include cookies in requests
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;